<template>
  <div style="margin-bottom: 20px;">
    已选中{{ selectedRowKeys.length }}条数据
    <a-space style="margin-left: 20px;">
      <a-button
        type="primary"
        :disabled="selectedRowKeys.length === 0"
        @click="handleBatchDelete"
        >批量删除</a-button
      >
      <a-button
        type="primary"
        :disabled="selectedRowKeys.length === 0"
        @click="exportExcel"
        >导出</a-button
      >
    </a-space>
  </div>
  <a-table
    :dataSource="dataSource"
    :columns="columns"
    :scroll="{ x: 1530 }"
    :pagination="false"
    @resizeColumn="handleResizeColumn"
    class="mb40"
    :row-key="record => record.id"
    :row-selection="{
      selectedRowKeys: selectedRowKeys,
      onChange: onSelectChange,
      onSelect: onRowSelected,
      onSelectAll: onRowSelectedAll
    }"
  >
    <template #moduleType="{ record }">
      {{ moduleTypeObject[record.moduleType] }}
    </template>
    <template #category1="{ record }">
      <a-tooltip>
        <template #title>{{
          record.fixSkcs.filter(v => v.sort - 0 === 1)[0]?.skcCode || ''
        }}</template>
        <div class="list-ellipsis">
          {{ record.fixSkcs.filter(v => v.sort - 0 === 1)[0]?.skcCode || '' }}
        </div>
      </a-tooltip>
    </template>
    <template #category2="{ record }">
      <a-tooltip>
        <template #title>{{
          record.fixSkcs.filter(v => v.sort - 0 === 2)[0]?.skcCode || ''
        }}</template>
        <div class="list-ellipsis">
          {{ record.fixSkcs.filter(v => v.sort - 0 === 2)[0]?.skcCode || '' }}
        </div>
      </a-tooltip>
    </template>
    <template #category3="{ record }">
      <a-tooltip>
        <template #title>{{
          record.fixSkcs.filter(v => v.sort - 0 === 3)[0]?.skcCode || ''
        }}</template>
        <div class="list-ellipsis">
          {{ record.fixSkcs.filter(v => v.sort - 0 === 3)[0]?.skcCode || '' }}
        </div>
      </a-tooltip>
    </template>
    <template #category4="{ record }">
      <a-tooltip>
        <template #title>{{
          record.fixSkcs.filter(v => v.sort - 0 === 4)[0]?.skcCode || ''
        }}</template>
        <div class="list-ellipsis">
          {{ record.fixSkcs.filter(v => v.sort - 0 === 4)[0]?.skcCode || '' }}
        </div>
      </a-tooltip>
    </template>
    <template #category5="{ record }">
      <a-tooltip>
        <template #title>{{
          record.fixSkcs.filter(v => v.sort - 0 === 5)[0]?.skcCode || ''
        }}</template>
        <div class="list-ellipsis">
          {{ record.fixSkcs.filter(v => v.sort - 0 === 5)[0]?.skcCode || '' }}
        </div>
      </a-tooltip>
    </template>
    <template #deal="{ record }">
      <div class="tal">
        <a-button type="link" size="small" @click="changeVisible(record)"
          >查看/编辑</a-button
        >
        <a-popconfirm
          title="确定删除该配置?"
          ok-text="确定"
          cancel-text="取消"
          trigger="click"
          @confirm="() => deleteFun({ ...record })"
          @cancel="cancel"
        >
          <a-button type="link" size="small">删除</a-button>
        </a-popconfirm>
      </div>
    </template>
  </a-table>
</template>
<script>
import { inject, toRefs, ref } from 'vue'
export default {
  setup() {
    const columns = ref([
      {
        title: '站点',
        dataIndex: 'siteName',
        key: 'siteName',
        resizable: true,
        width: 140,
        align: 'center'
      },
      {
        title: '终端',
        dataIndex: 'terminalName',
        key: 'terminalName',
        resizable: true,
        width: 100,
        align: 'center'
      },
      {
        title: '位置',
        dataIndex: 'moduleType',
        slots: { customRender: 'moduleType' },
        resizable: true,
        width: 160,
        align: 'center'
      },
      {
        title: '主商品SKC',
        dataIndex: 'mainSkc',
        key: 'mainSkc',
        resizable: true,
        width: 180,
        align: 'center'
      },
      {
        title: '坑1',
        dataIndex: 'category1',
        slots: { customRender: 'category1' },
        width: 200,
        resizable: true,
        align: 'center'
      },
      {
        title: '坑2',
        dataIndex: 'category2',
        slots: { customRender: 'category2' },
        resizable: true,
        align: 'center',
        width: 220
      },
      {
        title: '坑3',
        slots: { customRender: 'category3' },
        key: 'name',
        resizable: true,
        align: 'center',
        width: 220
      },
      {
        title: '坑4',
        slots: { customRender: 'category4' },
        key: 'name',
        resizable: true,
        align: 'center',
        width: 220
      },
      {
        title: '坑5',
        slots: { customRender: 'category5' },
        key: 'name',
        align: 'center',
        width: 220
      },
      {
        title: '操作',
        slots: { customRender: 'deal' },
        key: 'deal',
        fixed: 'right',
        width: 180
      }
    ])
    return {
      handleResizeColumn: (w, col) => {
        col.width = w
      },
      columns,
      ...toRefs(inject('initState'))
    }
  }
}
</script>
<style>
.list-ellipsis {
  width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
